import Vue from 'vue'
import Vuex from 'vuex'

import user from '@/store/User'
import department from '@/store/Department'
import api from '@/store/Api'
import uploader from '@/store/Uploader'
import preview from '@/store/MaterialPreview'
import views from '@/store/Views'
import permission from '@/store/Permission'
import config from '@/store/Config'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        api,
        user,
        department,
        uploader,
        preview,
        views,
        permission,
        config
    },
    state: {

    },
    mutations: {

    },
    actions: {

    }
})